import React, {
  useState, useEffect, useMemo, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { Link as ReactLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import {
  ArrowDropDown, Lock, Link, RequestQuote, PhotoLibrary, ImageSearch, AddBox,
} from '@mui/icons-material';

const Sidebar = ({
  maxView,
  setMaxView,
  view,
  setView,
  calculationsData,
  setCalculationsData,
  showSidebar,
  setShowSidebar,
}) => {
  const [asidebarHeight, setAsidebarHeight] = useState('0px');
  const sidebar = useRef();
  const userName = localStorage.getItem('user-name');

  const onAnimationEnd = () => {
    if (!sidebar.current?.classList?.contains('disappear-bar')) return;
    setShowSidebar(false);
  };

  useMemo(() => {
    if (view <= maxView) return;
    setMaxView(view);
  }, [view]);

  useEffect(() => {
    const windowHeight = window.innerHeight - (document.querySelector('nav')?.offsetHeight || 0) - 1;
    setAsidebarHeight(document.querySelector('html').offsetHeight > windowHeight
      ? document.querySelector('html')?.offsetHeight : windowHeight);
  }, [showSidebar]);

  return (
    <>
      <div />
      {showSidebar
      && (
        <aside
          id="sidebar"
          ref={sidebar}
          style={{ minHeight: `${asidebarHeight}px` }}
          onAnimationEnd={onAnimationEnd}
        >
          {userName
          && (
          <div className="welcome-message">
            <p className="name">{`¡Hola ${userName}`}</p>
            <p className="message">Bienvenido a Metior!</p>
          </div>
          )}

          <Accordion
            className="accordion"
            defaultExpanded
            sx={{ boxShadow: 'none', margin: '10px 0 30px 0 !important' }}
          >
            <AccordionSummary
              className="accordion-summary-sidebar"
              expandIcon={<ArrowDropDown />}
              aria-controls="panel1a-content"
              id="panel0a-header-asidebar"
              style={{ margin: '0', minHeight: '0' }}
            >
              Cotizar diseño
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0' }}>
              {maxView >= 1
              && (
                <button
                  onClick={() => setView(1)}
                  className={`${view !== 1 ? 'select-button' : 'selected-button select-button'}`}
                  type="button"
                >
                  Seleccione su maquina
                </button>
              )}

              {maxView >= 2
              && (
                <button
                  onClick={() => setView(2)}
                  className={`${view !== 2 ? 'select-button' : 'selected-button select-button'}`}
                  type="button"
                >
                  Materia Prima
                </button>
              )}

              {maxView >= 3
              && (
                <button
                  onClick={() => setView(3)}
                  className={`${view !== 3 ? 'select-button' : 'selected-button select-button'}`}
                  type="button"
                >
                  Diseño
                </button>
              )}

              {maxView >= 4
              && (
                <button
                  onClick={() => setView(4)}
                  className={`${view !== 4 ? 'select-button' : 'selected-button select-button'}`}
                  type="button"
                >
                  Costo de electricidad
                </button>
              )}

              {maxView >= 5
              && (
                <button
                  onClick={() => setView(5)}
                  className={`${view !== 5 ? 'select-button' : 'selected-button select-button'}`}
                  type="button"
                >
                  Costo del operador
                </button>
              )}

              {maxView >= 6
              && (
                <button
                  onClick={() => setView(6)}
                  className={`${view !== 6 ? 'select-button' : 'selected-button select-button'}`}
                  type="button"
                >
                  Precio de venta
                </button>
              )}

              {maxView >= 7
              && (
                <button
                  onClick={() => setView(7)}
                  className={`${view !== 7 ? 'select-button' : 'selected-button select-button'}`}
                  type="button"
                >
                  Resultados
                </button>
              )}
              {(calculationsData?.imgDesign?.url || calculationsData.imgDesign?.completeBase64)
              && (
                <div style={{ position: 'relative' }}>
                  <img
                    style={{
                      width: '100%', height: '100px', objectFit: 'contain', marginTop: '10px',
                    }}
                    alt="design-img"
                    src={calculationsData.imgDesign?.url
                      ? calculationsData.imgDesign?.url : calculationsData.imgDesign?.completeBase64}
                  />
                  <button
                    style={{
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '20px',
                      height: '20px',
                      top: '10px',
                      right: '20px',
                      border: 'none',
                      borderRadius: '100%',
                      boxShadow: '0 0 3px rgb(0 0 0 / 30%)',
                      cursor: 'pointer',
                    }}
                    type="button"
                    onClick={() => setCalculationsData({ ...calculationsData, imgDesign: null })}
                  >
                    x
                  </button>
                </div>
              )}
            </AccordionDetails>
          </Accordion>

          <Accordion
            defaultExpanded
            id="panel0a-accordion-asidebar"
            sx={{ boxShadow: 'none', margin: '30px 0 !important' }}
          >
            <AccordionSummary
              className="accordion-summary-sidebar"
              expandIcon={<ArrowDropDown />}
              aria-controls="panel1a-content"
              id="panel0a-header-asidebar"
              style={{ margin: '0', minHeight: '0' }}
            >
              Cotizaciones
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0' }}>
              <div className="icon-wrapper">
                <ReactLink to="/metior/user-quotations" style={{ textDecoration: 'none' }}>
                  <button
                    className="select-button"
                    style={{ display: 'flex', alignItems: 'end', boxShadow: 'none' }}
                    type="button"
                  >
                    <RequestQuote style={{ fontSize: '20px', color: '#bababa', marginRight: '5px' }} />
                    Cotizaciones de costos
                  </button>
                </ReactLink>
                <ReactLink to="/metior/clients-quotations" style={{ textDecoration: 'none' }}>
                  <button
                    className="select-button"
                    style={{ display: 'flex', alignItems: 'end', boxShadow: 'none' }}
                    type="button"
                  >
                    <RequestQuote style={{ fontSize: '20px', color: '#bababa', marginRight: '5px' }} />
                    Cotizaciones de clientes
                  </button>
                </ReactLink>
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion
            defaultExpanded
            id="panel0a-accordion-asidebar"
            sx={{ boxShadow: 'none', margin: '30px 0 !important' }}
          >
            <AccordionSummary
              className="accordion-summary-sidebar"
              expandIcon={<ArrowDropDown />}
              aria-controls="panel1a-content"
              id="panel0a-header-asidebar"
              style={{ margin: '0', minHeight: '0' }}
            >
              Diseños
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0' }}>
              <div className="icon-wrapper">
                <button
                  className="select-button"
                  style={{ display: 'flex', alignItems: 'end', boxShadow: 'none' }}
                  type="button"
                >
                  <PhotoLibrary style={{ fontSize: '20px', color: '#bababa', marginRight: '5px' }} />
                  Mis diseños guardados
                  <Lock style={{ fontSize: '10px', color: '#00000082', transform: 'translate(0px, -10px)' }} />
                </button>
                <a
                  style={{ textDecoration: 'none' }}
                  href="https://www.sagaon.tech/collections/vectores-corte-y-grabado-cnc-laser-y-router-gratis"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button
                    className="select-button"
                    style={{ display: 'flex', alignItems: 'end', boxShadow: 'none' }}
                    type="button"
                  >
                    <ImageSearch style={{ fontSize: '20px', color: '#bababa', marginRight: '5px' }} />
                    Libreria de diseños
                  </button>
                </a>
                <button
                  className="select-button"
                  style={{ display: 'flex', alignItems: 'end', boxShadow: 'none' }}
                  type="button"
                >
                  <AddBox style={{ fontSize: '20px', color: '#bababa', marginRight: '5px' }} />
                  Generador de cajas
                  <Lock style={{ fontSize: '10px', color: '#00000082', transform: 'translate(0px, -10px)' }} />
                </button>
              </div>
            </AccordionDetails>
          </Accordion>

          <a
            href="https://www.facebook.com/Sagaon.Tech/"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <p
              aria-controls="panel1a-content"
              id="panel0a-header-asidebar"
              style={{
                margin: '0 0 30px 0',
                minHeight: '0',
                display: 'flex',
                padding: '0',
                fontSize: '14px',
              }}
            >
              <Link style={{ fontSize: '20px', color: '#bababa', marginRight: '5px' }} />
              Comunidad
            </p>
          </a>
          <a
            href="https://www.sagaon.tech/blogs/academia"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <p
              aria-controls="panel1a-content"
              id="panel0a-header-asidebar"
              style={{
                margin: '0 0 30px 0',
                minHeight: '0',
                display: 'flex',
                padding: '0',
                fontSize: '14px',
              }}
            >
              <Link style={{ fontSize: '20px', color: '#bababa', marginRight: '5px' }} />
              Academia
            </p>
          </a>
          <div
            style={{
              textAlign: 'center',
              width: '100%',
              margin: '0',
              marginBottom: '20px',
              padding: '10px',
              backgroundColor: '#dedede',
              borderRadius: '5px',
              fontStyle: 'italic',
              fontSize: '14px',
            }}
          >
            &quot; Lo que no se mide, no se puede mejorar &quot; ~ Lord Kelvin
          </div>
          {/* <div
            style={{
              textAlign: 'center',
              width: '100%',
              margin: '0',
              marginBottom: '20px',
              padding: '20px 5px 10px 10px',
              backgroundColor: '#dedede',
              borderRadius: '5px',
            }}
          >
            <h5 style={{ margin: '0' }}>Esta es una version BETA de METIOR.</h5>
            <p style={{ marginBottom: '10px', fontSize: '12px' }}>Y podra presentar cambios en cualquier momento</p>
          </div> */}
        </aside>
      )}
    </>
  );
};

Sidebar.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    machine: PropTypes.shape({
      id: PropTypes.string,
      lengthCut: PropTypes.number,
      name: PropTypes.string,
      productModel: PropTypes.string,
      shopifyPrice: PropTypes.number,
      url: PropTypes.string,
      witdhCut: PropTypes.number,
    }),
    imgDesign: PropTypes.string,
  }).isRequired,
  setCalculationsData: PropTypes.func.isRequired,
  maxView: PropTypes.number.isRequired,
  setMaxView: PropTypes.func.isRequired,
  showSidebar: PropTypes.bool.isRequired,
  setShowSidebar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
    maxView: state.maxView,
    showSidebar: state.showSidebar,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
  setMaxView: (values) => dispatch({
    type: 'SET_MAX_VIEW',
    payload: values,
  }),
  setShowSidebar: (values) => dispatch({
    type: 'SET_SHOW_SIDE_BAR',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Sidebar));
